import { OnInit, Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PersonInfoService } from './modules/common/associates/service/personinfo.service';
import { JWTService } from './modules/fingerprint/fingerprint-summary/service/jwt.service';
import { LocationService } from './modules/fingerprint/fingerprint-summary/service/location.service';
import { PayrollHrManagerServices } from './modules/hr/service/payrollHrManager.service';
import { ApplicationResponse } from './modules/users/admin-users/models/application';
import { UserResponse } from './modules/users/admin-users/models/userVO.model';
import { ApplicationService } from './modules/users/admin-users/service/application.service';
import { UserRoleProfileService } from './modules/users/admin-users/service/userrole-profile.service';
import { LoggedInInfo } from './shared/model/login.model';
import { LoginService } from './shared/service/login.service';
import { NgxUiLoaderDemoService } from './shared/service/ngx-ui-loader-demo.service';
import { Title } from '@angular/platform-browser';
import { Constants } from './shared/pipes/constants';
import { interval } from 'rxjs';
import { InactivityService } from './shared/service/inactivity.service';
declare let $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',

})

export class AppComponent implements OnInit {
  authorityCode: string;
  @Input() userName: string = "";
  public loggedInInfo: LoggedInInfo;
  @Input() appName: string = "";
  @Input() profileName: string = "";
  @Input() showFlag: boolean = null;
  private refreshFalg: boolean = true;
  constructor(private router: Router, private loginService: LoginService,private inactivityService: InactivityService,
    private applicationService: ApplicationService, private userRoleProfile: UserRoleProfileService,
    public demoService: NgxUiLoaderDemoService, private personInfoService: PersonInfoService, private jwtService: JWTService,
    private locationService: LocationService, private payrollHrManagerServices: PayrollHrManagerServices, private titleService: Title, private activateRoute: ActivatedRoute) { }

  ngOnInit(): void {
    // Check every 10 minutes
    interval(10 * 60 * 1000).subscribe(() => {
      let expireTime = this.loginService.loggedInInfo != undefined && this.loginService.loggedInInfo != null && this.loginService.loggedInInfo.expiresOn != undefined && this.loginService.loggedInInfo.expiresOn != null
      ?this.loginService.loggedInInfo.expiresOn.getTime():null;
      let expireTimeLess5Mins = expireTime != null? expireTime-(1000*60*5):null;
      let date = new Date().getTime()
      if(this.refreshFalg && expireTimeLess5Mins!= null &&expireTime != null && expireTimeLess5Mins <= date ){
        this.refreshFalg = false;
        console.log("refresh token excecuted")
        this.loginService.getRefreshAccessToken(this.loggedInInfo.homeAccountId, sessionStorage.getItem("appName")).subscribe(dataToken => {
          if (dataToken != null) {
            this.loggedInInfo = this.loginService.toAuthneticationProcess(dataToken as any);
            this.refreshFalg = true;
          }
        });
      }
    });
    if (window.location.href.includes("code")) {
      let path: string = window.location.href;
      let pathList = path.split("?");
      let tempstr: string[] = pathList[1].split("=");
      this.authorityCode = tempstr[1].split("&")[0];
      if (this.authorityCode != undefined) {
        this.loginService.getAccessToken(this.authorityCode, sessionStorage.getItem("appName")).subscribe({next: (response) => {
          if (response != null) {
            this.loggedInInfo = this.loginService.toAuthneticationProcess(response as any);
            this.userName = this.loggedInInfo.userName;
            this.applicationService.getApplicationByName(sessionStorage.getItem("appName"),
              this.loggedInInfo.displayableId).subscribe(data => {
                let appResponse: ApplicationResponse = data as any;
                if (appResponse.apiResponseVO.type == Constants.API_RESPONSE_TYPE_SUCCESS && appResponse.applicationVOList != undefined && appResponse.applicationVOList != null
                  && appResponse.applicationVOList.length > 0 && appResponse.applicationVOList[0].applicationId > 0) {
                  this.applicationService.application = appResponse.applicationVOList[0];
                  this.appName = this.applicationService.application.name;
                  this.titleService.setTitle(this.appName.toUpperCase()); 
                  this.userRoleProfile.getUsersDetailsById(this.loggedInInfo.displayableId, this.loggedInInfo.displayableId,
                    this.applicationService.application.applicationId).subscribe(dataResp => {
                      let userResp = dataResp as UserResponse;
                      // console.log("dataResp " + userResp);
                      // console.log(" dataResp apiResponseVO " +userResp.apiResponseVO);
                      if (userResp.apiResponseVO.type == Constants.API_RESPONSE_TYPE_SUCCESS && userResp.userVOList != undefined && userResp.userVOList != null && userResp.userVOList.length > 0) {
                        this.userRoleProfile.userVO = userResp.userVOList[0];
                        // console.log(this.userRoleProfile.userVO);
                        
                        this.profileName = userResp.userVOList[0].profileName;
                        // console.log(this.profileName);
                        sessionStorage.setItem("isLoggedin", "Y");
                        this.personInfoService.isConsecratedPerson(this.userRoleProfile.getUserEmailID()).subscribe(data => {
                          if (data) {
                            this.showFlag = true;
                          } else {
                            this.showFlag = false;
                          }
                        });
                        if (this.applicationService.application.name == "fingerprint") {
                          //     let token: UserToken = new UserToken();
                          //     token.emailAddress = this.loggedInInfo.displayableId;
                          //     token.azureAccesToken = this.loggedInInfo.accessToken;
                          //     this.jwtService.getJWTToken(token).subscribe(tokenData => {

                          //   this.jwtService.jwtToken = tokenData as any;
                          //  if (this.jwtService.jwtToken.jwt_token != undefined) {

                          //     this.locationService.setheaders();
                          //   }

                          // });
                          this.router.navigate(["/app-fingerprint-type/app-summary-fingerprint"], { queryParams: { id: new Date().getTime() } });

                        }
                        // OMI 05/01 FOR PSMS/DIRECTORY
                        else if (this.applicationService.application.name == "directory") {

                          this.router.navigate(["/app-psms/app-parishschools"], { queryParams: { id: new Date().getTime() } });

                        }
                        else if (this.applicationService.application.name == "seminarian") {

                          this.router.navigate(["/app-seminarian/app-seminarian-summary"], { queryParams: { type: 'S', id: new Date().getTime() } });

                        } else if (this.applicationService.application.name == "priest") {

                          this.router.navigate(["/app-priest/app-priest-summary"], { queryParams: { id: new Date().getTime() } });

                        }
                        else if (this.applicationService.application.name == "studentipm") {

                          this.router.navigate(["/app-studentipm/app-student-summary"], { queryParams: { id: new Date().getTime() } });

                        }
                        else if (this.applicationService.application.name == "humanresources") {
                          if (this.userRoleProfile.userVO.profileName == "Super Admin" || this.userRoleProfile.userVO.profileName == "Portal Admin") {
                            this.userRoleProfile.locationCode = 0;
                            this.userRoleProfile.locationName = 'All Locations';
                            this.router.navigate(["/app-humanresource/app-humanresource-summary"], { queryParams: { id: new Date().getTime() } });

                          } else {
                            this.payrollHrManagerServices.getlocationsByEmailandProfileName(this.userRoleProfile.getUserEmailID(), this.userRoleProfile.userVO.profileName).subscribe(data => {
                              if (data.apiResponseVO.type == Constants.API_RESPONSE_TYPE_SUCCESS && data.payrollHrManagersLocationVOList != undefined && data.payrollHrManagersLocationVOList != null && data.payrollHrManagersLocationVOList.length > 0) {
                                let locationsInfoList = data.payrollHrManagersLocationVOList;
                                this.userRoleProfile.locationCode = locationsInfoList[0].locationCode;
                                this.userRoleProfile.locationName = locationsInfoList[0].locationName;
                                this.router.navigate(["/app-humanresource/app-humanresource-summary"], { queryParams: { id: new Date().getTime() } });
                              } else {
                                sessionStorage.setItem("isLoggedin", "N");
                                // this.router.navigate(["/app-humanresource/app-humanresource-summary"], { queryParams: { id: new Date().getTime() } });
                                this.router.navigate(['login'], { queryParams: { appName: this.applicationService.application.name, id: new Date().getTime(), auth: 'N' } });
                              }
                            });
                          }
                        } else if (this.applicationService.application.name == "deacon") {
                          this.router.navigate(["/app-deacon/app-deacon-summary"], { queryParams: { id: new Date().getTime() } });
                        }
                        else {
                          this.router.navigate(["/app-associate-type/app-summary"], { queryParams: { id: new Date().getTime() } });
                        }
                      } else {
                        sessionStorage.setItem("isLoggedin", "N");
                        this.router.navigate(['login'], { queryParams: { appName: this.applicationService.application.name, id: new Date().getTime(), auth: 'N' } });
                      }
                    }, error => {
                      if (error != undefined) {
                        sessionStorage.setItem("isLoggedin", "N");
                        this.router.navigate(['login'], { queryParams: { appName: this.applicationService.application.name, id: new Date().getTime(), auth: 'N' } });
                      }
                    });
                } else {
                  sessionStorage.setItem("isLoggedin", "N");
                  this.router.navigate(['login'], { queryParams: { appName: sessionStorage.getItem("appName"), id: new Date().getTime(), auth: 'N', } });
                }
              });

          } else {
            sessionStorage.setItem("isLoggedin", "N");
            this.router.navigate(['login'], { queryParams: { appName: sessionStorage.getItem("appName"), id: new Date().getTime(), auth: 'N' } });
          }
        },
        error: (err) => {
          console.error('Error occurred:', err);
          // Show a user-friendly error message
          //this.errorMessage = 'Something went wrong. Please try again later.';
          // You can also use a toast, alert, or snackbar here
        }});
      }
    } else if (window.location.href.includes("error")){
        this.router.navigate(['login'], { queryParams: { appName: sessionStorage.getItem("appName"), id: new Date().getTime(), auth: 'N' } });
    } else if (window.location.hash.substring(1, 2) == "/" && window.location.hash != "") {
      this.login()
    } else {
      if (localStorage.getItem('Username') == 'logout') {
        window.location.href = this.loginService.getLogOutEndpoint();
      } else {
        this.login()
      }
    }
  }
  onActivate(e) {
  }
  login() {
    let appNameFlag: boolean;
    let path: string = window.location.href;
    appNameFlag = path.includes("appName");
    if (appNameFlag) {
      let pathList = [];
      pathList = path.split("?");
      let pageName = [];
      pageName = pathList[pathList.length - 1].split("=");
      this.appName = pageName[1];
      if (sessionStorage.getItem("appName") != null && sessionStorage.getItem("appName") != undefined && sessionStorage.getItem("appName") != "") {
        this.appName = sessionStorage.getItem("appName");
          // Change the title from psms to directory
          // if(this.appName == "psms"){
          //   this.appName = 'directory';
          // }
        this.titleService.setTitle(this.appName.toUpperCase());
      } else {
        this.titleService.setTitle(this.appName.toUpperCase());
      }
      if (this.appName == 'consecrated' || this.appName == 'fingerprint' || this.appName == 'seminarian' || this.appName == 'deacon' ||
        this.appName == 'priest' || this.appName == 'voluntary' || this.appName == "humanresources" || this.appName == "studentipm" || this.appName == "directory") {
        sessionStorage.setItem("appName", this.appName);
        // this.router.navigate(['login'], { queryParams: { appName: this.appName, id: new Date().getTime() } });
        window.location.href = this.loginService.getSignInEndpoint(this.appName);
      } else {
        sessionStorage.setItem("isLoggedin", "N");
        this.router.navigate(['login'], { queryParams: { appName: sessionStorage.getItem("appName"), id: new Date().getTime(), auth: 'A' } });
      }
    } else {
      if (sessionStorage.getItem("isLoggedin") == "Y" && sessionStorage.getItem("appName") != null && sessionStorage.getItem("appName") != undefined && sessionStorage.getItem("appName").trim() != "") {
        window.location.href = this.loginService.getSignInEndpoint(this.appName)
      } else {
        sessionStorage.setItem("isLoggedin", "N");
        this.router.navigate(['login'], { queryParams: { appName: sessionStorage.getItem("appName"), id: new Date().getTime(), auth: 'A' } });
      }
    }

  }
}
